import { render, staticRenderFns } from "./frontend_settings.vue?vue&type=template&id=559c617c&"
import script from "./frontend_settings.vue?vue&type=script&lang=js&"
export * from "./frontend_settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports